// apiurl: 'https://api.superelf-eredivisie.nl/'
export const environment = {
  production: true,
  apiurl: 'https://api.superelf-eredivisie.nl/',
  apiVersion: '26'
};
